import { initPagingOptions } from '@/coreDomainsModule/paging';
import { IBulkEditBusinessState } from './types';

/**
 * IEditBusinessStateを初期化する関数
 * @returns - 初期状態のIEditBusinessState型のオブジェクト
 */
export const initBulkEditBusinessState = (): IBulkEditBusinessState => {
  return {
    businessMode: 'aggregateBusiness',
    loadingStatus: { type: 'loading' },
    pagingOptions: initPagingOptions(30),
    sortInfo: { key: 'id', type: 'ASC' },
    filterItems: [],
    dataList: [],
    checkedIds: new Set(),
    editDropdownState: false,
  };
};
